import { render, staticRenderFns } from "./MFeatures.vue?vue&type=template&id=2f208c68&scoped=true"
import script from "./MFeatures.vue?vue&type=script&lang=js"
export * from "./MFeatures.vue?vue&type=script&lang=js"
import style0 from "./MFeatures.vue?vue&type=style&index=0&id=2f208c68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f208c68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSkeletonLoader,VSwitch})
